import React, { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { API } from "../../auth/AuthContext";
import { toast } from "sonner";

export default function UserDeleteModal({ user, onClose, onDeleted }) {
  const [confirmText, setConfirmText] = useState("");
  const [deleting, setDeleting] = useState(false);
  useEffect(() => { if (!user) setConfirmText(""); }, [user]);
  if (!user) return null;
  const expected = user.email || user.name || "DELETE";
  const ok = confirmText.trim() === expected.trim();
  const submit = async () => {
    if (!ok) return;
    setDeleting(true);
    try {
      await axios.delete(`${API}/admin/users/${user.user_id}`, { withCredentials: true });
      toast.success("User deleted");
      onDeleted?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Delete failed");
    } finally { setDeleting(false); }
  };
  return (
    <Dialog open={!!user} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="bg-white border border-[var(--zc-border)] max-w-md" data-testid="user-delete-modal">
        <DialogHeader>
          <DialogTitle className="zc-headline text-2xl flex items-center gap-2" style={{ color: "var(--zc-danger,#dc2626)" }}>
            <AlertTriangle size={20} /> Delete user
          </DialogTitle>
        </DialogHeader>
        <div className="text-sm text-[var(--zc-text-2)]">
          You're about to soft-delete <b className="text-[var(--zc-text)]">{user.name || user.email}</b>. They will be signed out from all devices, blocked from new bookings, and their data will remain for audit. This action can be reversed by editing the user record directly in the database.
        </div>
        <div className="mt-4">
          <label className="text-xs text-[var(--zc-text-3)] block mb-1">Type <b className="text-[var(--zc-text)]">{expected}</b> to confirm</label>
          <input value={confirmText} onChange={(e) => setConfirmText(e.target.value)} className="zc-input h-10 px-3 w-full text-sm" data-testid="user-delete-confirm" autoFocus />
        </div>
        <div className="flex justify-end gap-2 mt-5">
          <button onClick={onClose} className="px-4 h-10 zc-btn-ghost text-sm">Cancel</button>
          <button onClick={submit} disabled={!ok || deleting} className="px-5 h-10 text-sm rounded-md text-white disabled:opacity-40 transition-opacity" style={{ background: "var(--zc-danger,#dc2626)" }} data-testid="user-delete-submit">
            {deleting ? "Deleting…" : "Delete user"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
